export default "__VITE_ASSET__CncSQgkP__"